import { useEffect, useState } from "react";
import { finishCallback } from "../lib/auth";
import { t, type Lang } from "../lib/i18n";

export function HeronCallback({ onDone }: { onDone: () => Promise<void> | void }) {
  const [err, setErr] = useState("");
  const lang = ((localStorage.getItem("hiera.lang") as Lang) || "ru") as Lang;
  useEffect(() => {
    void (async () => {
      try {
        const ret = await finishCallback();
        await onDone();
        window.location.replace(ret || "/");
      } catch (e) {
        const msg = e instanceof Error ? e.message : "oauth_failed";
        setErr(msg === "registration_closed" ? t(lang, "regClosedErr") : msg);
      }
    })();
  }, [onDone, lang]);
  if (err) return <div className="pad">{err}</div>;
  return <div className="pad">Signing in…</div>;
}
